export function prefixZero(number: number) { return number < 10 ? `0${number}` : `${number}`; }

export function parseDateString(dateString: string): Date {
    const [datePart, timePart] = dateString.split(" ");
    const [day, month, year] = datePart.split("-").map(Number);
    const [hours, minutes, seconds] = timePart.split(":").map(Number);
  
    return new Date(year, month - 1, day, hours, minutes, seconds);
  }
export function parseDateStringBackBoneVisit(dateString: string): Date {
    const [datePart, timePart] = dateString.split(" ");
    const [year, month, day, ] = datePart.split("-").map(Number);
    const [hours, minutes, seconds] = timePart.split(":").map(Number);
  
    return new Date(year, month - 1, day, hours, minutes, seconds);
  }

  export const dateFormatPipe = 'dd-LLL-yyyy'